import script from "./SkillBusinesstypeEditView.vue?vue&type=script&lang=ts&setup=true"
export * from "./SkillBusinesstypeEditView.vue?vue&type=script&lang=ts&setup=true"

import "./SkillBusinesstypeEditView.vue?vue&type=style&index=0&id=9abf562a&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/jobs/MASSMEDIAN_MYPAGE_VIEW_PROD/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9abf562a"]])

export default __exports__